module.exports = __webpack_public_path__ + "img/avatar.29c7f33a.png";